import styles from "../../Dashboard.module.css";
import { getStatusColor } from "../../../../../utils/outorga/dashboard";
import { grantStatus } from "../../../../../utils/Enums/grantStatus";

const Header = ({ title, status }) => {
  return (
    <div className={styles.header}>
      <div className={styles.headerInfo}>
        <h3 className={styles.headerTitle} title={title}>
          {title}
        </h3>
      </div>

      <div
        className={styles.statusBadge}
        style={{ backgroundColor: getStatusColor(status) }}
        title={grantStatus[status]}
      >
        {grantStatus[status]}
      </div>
    </div>
  );
}

export default Header;